const APP_MODE_SUPPRESSIONS = ["app-download-cta", "post-checkout-credit", "post-checkout-referral"] as const

export type AppModeSuppression = (typeof APP_MODE_SUPPRESSIONS)[number]

export const isSuppressedInAppMode = (suppression: AppModeSuppression, isAppRequest: boolean): boolean => isAppRequest && APP_MODE_SUPPRESSIONS.includes(suppression)
